/* ######################################################################################################################## */
/* GENERIC VARS ########################################################################################################### */
/* ######################################################################################################################## */
var speed = 300;
var	ease  = 'easeInOutQuart';

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW ONLOAD) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).load(function()
{
});

/* ######################################################################################################################## */
/* SCRIPTS (DOCUMENT READY) ############################################################################################### */
/* ######################################################################################################################## */
jQuery(document).ready(function($)
{
	responsiveImg();                // Responsive images
	modalWindow(speed, ease);       // Modal window
	formValidation(speed, ease);    // Form validation

	// Prevent default anchor action
	jQuery('a').on('click', function(e)
	{
		if(jQuery(this).attr('href') == '#')
			e.preventDefault();
	});

	jQuery('.js-print').click(function() {
		window.print();
	});

	$('.js-gallery-slider').slick({
		arrows: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: true,
					prevArrow: '<a class="arrow-prev" href="#" title="Previous Image"></a>',
					nextArrow: '<a class="arrow-next" href="#" title="Next Image"></a>'
				}
			}
		],
		asNavFor: '.js-gallery-thumbs',
		focusOnSelect: true
	});

	$('.js-gallery-thumbs').slick({
		arrows: false,
		slidesToShow: 3,
		asNavFor: '.js-gallery-slider',
		focusOnSelect: true
	});
});

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW RESIZE) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).bind('resizeEnd', function()
{
	responsiveImg();     // Responsive images
});

// resizeEnd
jQuery(window).resize(function()
{
	if(this.resizeTO)
		clearTimeout(this.resizeTO);

	this.resizeTO = setTimeout(function()
	{
		jQuery(this).trigger('resizeEnd');
	}, 100);
});
